import { createStore, createLogger } from 'vuex'
import users from './modules/users'
import claim from './modules/claim'
import postpone from './modules/postpone'
import wizard from './modules/wizard'
import message from './modules/message'
import hotel from './modules/hotel'
import stopsale from './modules/stopsale'
import spolist from './modules/spolist'
import spoprice from './modules/spoprice'
import status from './modules/status'
import myClaims from './modules/myClaims'
import { useCookies } from "vue3-cookies";
import apiService from '@/services/api.service';

const { cookies } = useCookies();

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    state: {
        locale: 'ru',
        currency: null,
        config: {}
    },
    mutations: {
        setLocale (state, locale) {
            state.locale = locale
        },
        setCurrency (state, currency) {
            state.currency = currency
        },
        setConfig(state, config) {
            state.config = config
        }
    },
    actions: {
        loadConfig({ commit }) {
            apiService.getFrApi({
                url: 'config/getConfig',
                method: 'get',
                locale: this.locale
            }).then(response => {
                if(process.env.NODE_ENV !== 'production')
                    console.log('%c Loaded config: \n' + JSON.stringify(response.data.data, null, 4), 'background: #222; color: #94bd0fff');

                cookies.set('config', response.data.data, '1h');
                commit('setConfig', response.data.data)
            })
        }
    },
    modules: {
        users,
        claim,
        postpone,
        wizard,
        message,
        hotel,
        stopsale,
        spolist,
        spoprice,
        status,
        myClaims
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
